<template>
    <div class="main-container">
        <div>
            <div class="margintop-16" />
            <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />   
                <tl-header type="h1">Payroll Reports</tl-header>
            <!-- <toast-message style="margin-bottom: 10px;" message="We are currently upgrading our system, Please check later." :isClosed="false" type="error" :isToastEnable="true" />     -->
            <!-- <div class="income-tax-summary-box">
                <div class="income-tax-text">Payroll Reports</div>
                <div class="headingContainer">
                    <div class="headingLeftContainer">
                        <div class="custom-col-3">
                            <div class="sm-text-it-summary">Tax Regime</div>
                            <div class="sm-sub-text-it-summary">{{ employeeRegimeType }}</div>
                        </div> -->
                        <!-- <div class="custom-col-3">
                            <div class="sm-text-it-summary">Net Taxable Income</div>
                            <div class="sm-sub-text-it-summary">₹{{ netTaxableIncome }}</div>
                        </div>
                        <div class="custom-col-3">
                            <div class="sm-text-it-summary">Total Tax</div>
                            <div class="sm-sub-text-it-summary">₹{{ totalTax }}</div>
                        </div>
                        <div class="custom-col-3">
                            <div class="sm-text-it-summary">Tax to be paid this month</div>
                            <div class="sm-sub-text-it-summary">₹{{ taxToPaid }}<span class="sm-sub-text-right"></span>
                            </div>
                        </div> -->
                    <!-- </div>
                </div>
            </div> -->

            <div class="twoColumnGridDashboard margintop-16">
                <div class="ReportContainer">
                    <div>
                        <img src="@/assets/payslip.svg" alt="payslip">
                    </div>
                    <div class="reportMainContainer">
                        <div class="reportTitle">
                            <h3>Payslips</h3>
                            <p>Download payslip reports instantly for easy access to your earnings and deductions.</p>
                        </div>
                        <div class="reportDownload">
                            <div class="reportDownloadLeft">
                                <span>Month-Year</span>
                                <tl-select class="reportDownloadLeftTextField" :options="monthOptions"
                                    placeholder="Month-Year" v-model="payslipMonth" @change="(val) => payslipMonth = val" />
                            </div>
                            <div v-if="!ispayslipDownloading" @click="downloadEssPayslip()" class="reportDownloadRight">
                                <img src="@/assets/payslipPdf.svg" alt="">
                                <button>Download</button>
                            </div>
                            <div v-if="ispayslipDownloading" class="reportDownloadRight">
                                <div class="loader-container">
                                    <div class="loader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ReportContainer">
                    <div>
                        <img src="@/assets/itStatement.svg" alt="payslip">
                    </div>
                    <div class="reportMainContainer">
                        <div class="reportTitle">
                            <h3>IT Statement</h3>
                            <p>Effortlessely download your IT statement reports for a comprehensive view of your tax
                                information.</p>
                        </div>
                        <div class="reportDownload">
                            <div class="reportDownloadLeft">
                                <span>Financial Year</span>
                                <tl-select class="reportDownloadLeftTextField" labelText="year" :options="yearOptionsForITSheet"
                                    placeholder="Select Year" v-model="itYear" @change="(val) => {itMonth = val}" />
                            </div>
                            <div v-if="!isItStatementDownloading" @click="downloadEssITSheet()" class="reportDownloadRight">
                                <img src="@/assets/payslipPdf.svg" alt="">
                                <button>Download</button>
                            </div>
                            <div v-if="isItStatementDownloading" class="reportDownloadRight">
                                <div class="loader-container">
                                    <div class="loader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isCtcReportEnable" class="ReportContainer">
                    <div>
                        <img src="@/assets/compensationrupee.svg" alt="payslip">
                    </div>
                    <div class="reportMainContainer">
                        <div class="reportTitle">
                            <h3>Compensation</h3>
                            <p>Download compensation reports for a quick overview of your rewards and benefits.</p>
                        </div>
                        <div class="reportDownload downloadCompensation">
                            <div v-if="!isCompensationLoading" @click="downloadCtcReport()" class="reportDownloadRight">
                                <img src="@/assets/payslipPdf.svg" alt="">
                                <button>Download</button>
                            </div>
                            <div v-if="isCompensationLoading" class="reportDownloadRight">
                                <div class="loader-container">
                                    <div class="loader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ReportContainer">
                    <div>
                        <img src="@/assets/payslip.svg" alt="payslip">
                    </div>
                    <div class="reportMainContainer">
                        <div class="reportTitle">
                            <h3>YTD Report</h3>
                            <p>Use this option to download YTD report for the payroll.</p>
                        </div>
                        <div class="reportDownload">
                            <div class="reportDownloadLeft">
                                <span>Financial Year</span>
                                <tl-select class="reportDownloadLeftTextField" labelText="year" :options="yearOptions"
                                    placeholder="Select Year" v-model="itYear" @change="(val) => ytdMonth = val" />
                            </div>
                            <div v-if="!isytdDownloading" @click="downloadYtdsheet()" class="reportDownloadRight">
                                <img style="width: 19px; height: 22px;" src="@/assets/excelIcon.svg" alt="">
                                <button>Download</button>
                            </div>
                            <div v-if="isytdDownloading" class="reportDownloadRight">
                                <div class="loader-container">
                                    <div class="loader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ReportContainer">
                    <div>
                        <img src="@/assets/payslip.svg" alt="payslip">
                    </div>
                    <div class="reportMainContainer">
                        <div class="reportTitle">
                            <h3>FORM 16</h3>
                            <p>Use this option to download the Form 16 for the selected assessment year</p>
                        </div>
                        <div class="reportFormDownload">
                            <div class="formOptionContainer">
                                <div class="reportDownloadLeft">
                                    <span class="title-container">Report Type</span>
                                    <tl-select
                                    class="reportDownloadLeftTextField"        
                                    name="documentType"
                                    v-model="documentType"
                                    labelText="name"
                                    placeholder="Select Type"
                                    :multiple="false"
                                    :options="docTypeList"                                    
                                    data-vv-as="Document Type"
                                    @change="(val) => ondocumentTypeCHange(val)"
                                    />
                                </div>
                                <div class="reportDownloadLeft">
                                    <span class="title-container">Financial Year</span>
                                    <tl-select  
                                    class="reportDownloadLeftTextField"
                                    name="paymentYear"
                                    v-model="paymentYear"
                                    placeholder="Select Year"
                                    :multiple="false"
                                    :options="paymentYearList"
                                    @change="(val)=>paymentYear = val"
                                    data-vv-as="Payment Year"
                                    />
                                </div>
                            </div>
                            <div v-if="!isForm16Downloading" @click="downloadForm16Report()" class="reportDownloadRight styleReport">
                                <img src="@/assets/payslipPdf.svg" alt="">
                                <button>Download</button>
                            </div>
                            <div v-if="isForm16Downloading" class="reportDownloadRight styleReport">
                                <div class="loader-container">
                                    <div class="loader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="le_id =='51c82d11-3a72-459f-8a22-7db1a74d1615' || le_id == '415ab638-db6f-43e9-8a80-1aec05cd2259'" class="ReportContainer">
                    <div>
                        <img src="@/assets/payslip.svg" alt="payslip">
                    </div>
                    <div class="reportMainContainer">


                        <div class="reportTitle">
                            <h3>Additional Payslips</h3>
                            <p>Download payslip reports instantly for easy access to your earnings and deductions.</p>
                        </div>
                        <div class="reportDownload">
                            <div class="reportDownloadLeft">
                                <span>Month-Year</span>
                                <tl-select class="reportDownloadLeftTextField" :options="monthOptionsAdditionalPayslip"
                                    placeholder="Month-Year" v-model="payslipMonthAdditionalPayslip" @change="(val) => payslipMonthAdditionalPayslip = val" />
                            </div>
                            <div v-if="!ispayslipDownloading" @click="downloadEssAdditionalPayslip()" class="reportDownloadRight">
                                <img src="@/assets/payslipPdf.svg" alt="">
                                <button>Download</button>
                            </div>
                            <div v-if="isAdditionalpayslipDownloading" class="reportDownloadRight">
                                <div class="loader-container">
                                    <div class="loader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ReportContainer" v-if="isLeIdMatch">
                    <div>
                        <img src="@/assets/payslip.svg" alt="general report">
                    </div>
                    <div class="reportMainContainer">
                        <div class="reportTitle">
                            <h3>General Documents</h3>
                            <p>Use this option to download general documents</p>
                        </div>
                        <div class="reportDownload">
                            <div class="reportDownloadLeft">
                                <tl-select  
                                    class="generalReportDocumentDownload"
                                    :options="DocumentList"
                                    placeholder="Document Type"
                                    v-model="generalType"
                                    @change="(val) => generalType = val"
                                />
                            </div>
                            <div v-if="!isGeneralDownloading" @click="downloadGeneralReport()" class="reportDownloadRight">
                                <img src="@/assets/payslipPdf.svg" alt="">
                                <button>Download</button>
                            </div>
                            <div v-if="isGeneralDownloading" class="reportDownloadRight">
                                <div class="loader-container">
                                    <div class="loader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isClearTaxEnable" class="ReportContainer">
                    <div>
                        <img src="@/assets/payslip.svg" alt="payslip">
                    </div>
                    <div  class="reportMainContainer">
                        <div class="reportTitle">
                            <h3>IT RETRUNS</h3>
                            <p>Use this option to file tax with Clear tax</p>
                        </div>
                        <div class="reportFormDownload">
                            <div class="formOptionContainer">
                                <div class="reportDownloadLeft">
                                    <span>Report Type</span>
                                    <tl-select
                                    class="reportDownloadLeftTextField"        
                                    name="clearTaxDocumentType"
                                    v-model="clearTaxDocumentType"
                                    labelText="name"
                                    :multiple="false"
                                    :options="docTypeList"                                    
                                    data-vv-as="Document Type"
                                    @change="(val) => clearTaxDocumentType = val"
                                    />
                                </div>
                                <div class="reportDownloadLeft">
                                    <span>Financial Year</span>
                                    <tl-select  
                                    class="reportDownloadLeftTextField"
                                    name="clearTaxPaymentYear"
                                    v-model="clearTaxPaymentYear"
                                    :multiple="false"
                                    :options="paymentYearList"
                                    @change="(val)=>clearTaxPaymentYear = val"
                                    data-vv-as="Payment Year"
                                    />
                                </div>
                            </div>
                            <div v-if="!isclearTaxProcessing" @click="processClearTax()" class="reportDownloadRight styleReport">
                                <img src="@/assets/payslipPdf.svg" alt="">
                                <button>Process</button>
                            </div>
                            <div v-if="isclearTaxProcessing" class="reportDownloadRight styleReport">
                                <div class="loader-container">
                                    <div class="loader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <pop-up-message v-if="showSuccessMsg" :message="`Save Successfully.`" btnText="OK"
                @back="goBack"></pop-up-message>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
const crypto = require("crypto");

export default {
    data() {
        return {
            isLeIdMatch: false,
            isCtcReportEnable: false,
            leIdsList: ["a3121263-42cf-4a28-8ea9-6956ea1a8c93", "4fd63ea1-72ba-4e84-bd11-7f5619b5b46e", "6a49fea7-1c79-4e6e-a335-3f3452dc1639", "12c05899-8d59-4bbf-ab05-f5eefcafeb3f","51c82d11-3a72-459f-8a22-7db1a74d1615","148a0336-0544-4287-94a4-f07e45b2ba73","7444d6ac-899f-4582-bc8f-8ed7b617568b","6c786ee5-679d-4a3f-bd66-fc502c9f051a","415ab638-db6f-43e9-8a80-1aec05cd2259","758b6a5d-ad36-4248-9872-cd8ca076ac3a","e08a4949-6398-4112-b58d-44c2f9d89bd2","491c05fb-61c9-4e5f-aa2d-392b5eaf5c23", "c020d23c-e664-4c95-9e2d-0e08efd63b40"],
            ytdMonth: {},
            monthOptions: [],
            monthOptionsAdditionalPayslip:[],
            yearOptions: [],
            yearOption:[],
            yearOptionsForITSheet: [],
            month: "",
            itMonth: {},
            generalType: '', 
            payslipMonth: "",
            payslipMonthAdditionalPayslip:'',
            le_id_consist:false,
            employeeData: {},
            ispayslipDownloading: false,
            isAdditionalpayslipDownloading: false,
            paymentYear: '',
            isytdDownloading: false,
            isItStatementDownloading: false,
            isCompensationLoading: false,
            isForm16Downloading: false,
            toast: false,
            errmsg: "",
            DocumentList:[],
            date_of_joining: null,
            isFirstMonth: false,
            employeeObj: null,
            PlanName: null,
            itYear:'',
            documentType: null,
            documentList: null,
            paymentYearList: [],
            paymentYearLists:[],
            docTypeList: [],
            exemptionSection: "Exemption Under Section 10",
            it_plan_id: "",
            employeeId: "",
            instance: {
                le_id: "",
                employee_id: "",
                financial_year: "",
                it_plan_id: "",
            },
            hraData: {
                exemption10: {
                    HRA: {},
                    others: []
                }
            },
            data2: {
                exemption10: {

                },
                exemption17: [],
                deductionsUnderSection16: [],
                deductionsUnderChapterVIA: [],
                section24: [],
                previousEmploymentDetails: {},
                otherIncome: {},
                le_id: "",
                employee_id: "",
                financial_year: "",
                plan_id: "",
                regime_type: "",
            },
            employeeRegimeType: "",
            hraExemptionAmount: 0,
            chapterVIATotalAmount: 0,
            section24TotalAmount: 0,
            previousEmployerAmount: 0,
            otherIncomeAmount: 0,
            salaryPerk: [],
            tds_breakup_and_taxable_income: [],
            itSheet: [],
            first_name: "",
            last_name: "",
            ctc: "",
            code: "",
            totalIncomeTax: "",
            annualTax: "",
            showSuccessMsg: false,
            totalAmount_otherIncome: "",
            totalAmount_previousEmpDetails: "",
            netTaxableIncome: 0,
            totalTax: 0,
            taxToPaid: 0,
            isclearTaxProcessing:false,
            clearTaxPaymentYear:'',
            clearTaxDocumentType:null,
            isClearTaxEnable:false,
            employeeDataCode:"",
            le_id_list:["496ba4ab-5257-4b67-8438-cac3e5fdb313","f037166c-0cd4-4ffd-bc05-643feb7c2a50","1b10cc25-67fc-400a-bafc-879733dd1c7e","476bd85b-0c00-4329-9b92-2fa0ed3c3cf4","74a3cfcc-ef03-4933-ba0a-503e01dff6c5","12c05899-8d59-4bbf-ab05-f5eefcafeb3f","77b22d81-b325-4522-8d8d-fc4a0945896d", "c6549115-5a7f-4c98-b977-c49bb208c0ab", "076bbb46-9178-4cb4-9539-a46f23a9d757", "e5d057f9-dac4-4fc3-9a31-cdf8d76fbc63", "850fd007-76de-47ef-8db7-8792d076f47e", "3c35c1e7-b699-4fc5-9826-7ca9c8b58d9e", "f61aa852-0e3b-461c-9caf-dc18e3864e5c"],
            le_id_list_part_only:["98d4b7fe-9444-4f65-9d12-155eeffab56a"]
        };
    },
    computed: {

        le_id() {
            return localStorage.getItem("le_id")
        },

        empId() {
            return localStorage.getItem("empId")
        },

        ...mapState({
            payrollYear: state => state.payroll.runpayroll.payrollYear
        }),
        ...mapGetters({
            getleid: "onboard/legal_entities/legal_entity_ID",
            getleData: "onboard/legal_entities/record",
            getITSettingsData: "onboard/statutoryinfo/incometax/getITData"
        }),
        ...mapState({
            globalData: state => state.globalapi.globalData.data,
        }),
        ifHr() {
            return localStorage.getItem("userRole") == "HR" ? true : false;
        },
        ifEmployee() {
            return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
        },

    },

    mounted() {
        this.getItPlan();
        this.getPayrollMonths();
        this.getEmpProfileData();
        this.getPayrollMonthsForITSheet();
        this.getDocumentList();
        this.getPayrolMonthOptionsAdditionalPayslip();
        this.isLeIdMatch = this.leIdsList ? this.leIdsList.includes(this.le_id) : false;
        if(this.le_id_list.includes(this.le_id)){
            this.docTypeList=[{name:"PART A", value: "part_A"}, {name:"PART B", value: "part_B",},{name: 'Consolidated', value:'consolidated'}]
        }else if(this.le_id_list_part_only.includes(this.le_id)){
            this.docTypeList=[{name:"PART A", value: "part_A"}, {name:"PART B", value: "part_B"}]
        }else{
           this.docTypeList=[{name: 'Consolidated', value:'consolidated'}]
        }
    },
    activated() {
        this.getItPlan();
        this.getPayrollMonths();
        this.getEmpProfileData();
        this.getPayrollMonthsForITSheet();
    },
    methods: {
        ...mapActions({
            act_get_Report_Download_Form:"dashboard/organisation/utilities/itsheetandpayslip/getReportDownloadForm",
            act_fetchEmpById: "onboard/employees/fetchEmpDataById",
            act_getPayrollMonthList: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchPayrollMonthList',
            act_getPayrollMonthList_additional_payslip: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchPayrollMonthListAdditionalPayslip',
            fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
            act_fetchAll: "onboard/settings/salary_structure/fetchAll",
            act_fetchsalarycomponents: "onboard/settings/salary_component/fetchAllsalaryComponentsData",
            act_set_it_data: "dashboard/payroll/incometax/setItData",
            act_get_document_list: "dashboard/organisation/utilities/itsheetandpayslip/getDocumentList",
            act_get_plan: "dashboard/payroll/incometax/getPlan",
            act_save_it_plan: "dashboard/payroll/incometax/createItData",
            act_fetch_plan_name: "dashboard/payroll/incometax/getPlanName",
            getOrgLeList: "onboard/organization/getOrgLeIdList",
            act_download_new_payslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewPayslips",
            act_download_additional_payslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewAdditionalPayslips",
            act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
            act_download_new_itSheet: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewItsheet",
            act_ess_download_general_report:"dashboard/organisation/utilities/itsheetandpayslip/getEssDownloadGeneral",
            act_getCtcReport: "dashboard/organisation/utilities/itsheetandpayslip/downloadCtcReport",
            act_download_YTD_report:"dashboard/organisation/utilities/itsheetandpayslip/downloadYtdsheet",
            act_getPayrollMonthListForITSheet: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchPayrollMonthListForITSheet',
            act_clear_tax_integration:"dashboard/organisation/utilities/itsheetandpayslip/clearTaxIntegration",
            act_getform16_availability_check:"dashboard/organisation/utilities/itsheetandpayslip/fetchForm16AvailableCheck"

        }),
        async ondocumentTypeCHange(val){
            try{
             this.documentType =  val
             this.getForm16AvailableCheck()
            }catch(err){

            }
        },
        async getForm16AvailableCheck(){
          try{
            let payload={
              le_id:this.le_id,
              emp_code:this.employeeDataCode,
              type: this.documentType.value,
            }
           let res = await this.act_getform16_availability_check(payload)
           this.paymentYearList = []
           res.data.data.map(item=>{
               this.paymentYearList.push(item.paymentYear+ '-' +(item.paymentYear+1))
           })
          }catch(error){
            this.toast = true;
            this.errmsg = error.message;
          }
        },
        async getItPlan() {
            try {
                let res = await this.act_get_plan(this.empId)
                this.planList = res.data.payload.filter(ele => ele.is_plan_active == true);
                this.it_plan_id = this.planList.length && this.planList[0].id;
                if (this.it_plan_id) {
                    this.fetchRecord();
                }
            } catch (error) {
                this.toast = true;
                this.errmsg = error.message;
            }
        },

        async getEmpProfileData(){
            try {
                let obj = {
                    'employee_id': this.empId
                };
                let response = await this.act_getProfileData(obj);
                this.isCtcReportEnable = response.data.payload && response.data.payload[0].legalEntityDetails.enable_ctc_report;
                this.financial_year = response.data.payload[0].payrollDetails && response.data.payload[0].payrollDetails.year;
                this.date_of_joining = response.data.payload[0].date_of_joining ? response.data.payload[0].date_of_joining : '';
                this.employeeData = response.data.payload[0];
                this.employeeDataCode = response.data.payload[0].code
                this.employeeData.dob = new Date(this.employeeData.dob).toISOString().slice(0, 10);
                this.employeeData.date_of_joining = (new Date(this.employeeData.date_of_joining).toLocaleString().slice(0, 10)).split("/").join("-");
                this.isClearTaxEnable = response.data.payload && response.data.payload[0].legalEntityDetails.enable_clear_tax;
                const today = new Date();
                let currentYear = today.getFullYear();
                // const monthName = today.toLocaleString('default', { month: 'long' });
                // let monthArray = ["January", "February", "March", "April", "May", "June", "July"]
                // if (monthArray.includes(monthName)) {
                //     currentYear = Number(currentYear)
                // }
                const previousFiveYears = [];
                let basedOnDoj = 1
                // let dateOfJOiningModification =  this.employeeData.date_of_joining.split("-")[2];
                //   if((Number(currentYear)- Number(dateOfJOiningModification)) >3 ){
                //     basedOnDoj = 3
                //   }else{
                //     basedOnDoj = (Number(currentYear)- Number(dateOfJOiningModification))
                //   }
                for (let i = 0; i < basedOnDoj; i++) {
                    previousFiveYears.push((currentYear - (i + 1)) + "-" + (currentYear - i));
                }
                this.paymentYearList = previousFiveYears;

            } catch (error) {
                
            }
        },

        async fetchRecord() {
            this.instance.employee_id = this.empId;
            this.instance.financial_year = this.financial_year;
            this.instance.it_plan_id = this.it_plan_id;
            this.instance.le_id = this.le_id;
            let res = await this.act_set_it_data(this.instance)
            if (res.status) {
                this.data2.exemption10 = res.data.payload.Exemption10.HRA && res.data.payload.Exemption10.HRA.length == 0 ? this.hraData.exemption10 : res.data.payload.Exemption10;
                this.data2.exemption17 = res.data.payload.Exemption17;
                this.data2.deductionsUnderSection16 = res.data.payload.deductionsUnderSection16;
                this.data2.deductionsUnderChapterVIA = res.data.payload.deductionsUnderChapterVIA;
                this.data2.section24 = res.data.payload.section24;
                this.data2.previousEmploymentDetails = res.data.payload.previousEmploymentDetails;
                this.data2.otherIncome = res.data.payload.otherIncome;
                this.totalAmount_otherIncome = this.data2.otherIncome&&this.data2.otherIncome.reduce((total, i) => {
                    total = total + i.planned;
                    return total;
                }, 0)
                this.salaryPerk = res.data.payload&&res.data.payload.Salary;
                this.tds_breakup_and_taxable_income = res.data.payload.tds_breakup_and_taxable_income&&res.data.payload.tds_breakup_and_taxable_income;
                this.itSheet = res.data.payload.itSheet&&res.data.payload.itSheet;
                let itSheetLength = this.itSheet.length;
                this.netTaxableIncome = this.itSheet[0] ? this.itSheet[0].taxableIncome : 0;
                this.totalTax = this.itSheet[0] ? this.itSheet[0].totalTax : 0;
                this.taxToPaid = this.itSheet[0] ? this.itSheet[0].tds : 0;
                if (res.data.payload.regime_type == "newregime") {
                    this.employeeRegimeType = "New Regime"
                } else if (res.data.payload.regime_type == "oldregime") {
                    this.employeeRegimeType = "Old Regime"
                }
                //console.log("TDS data show", this.tds_breakup_and_taxable_income);
                //console.log("IT sheet data ",this.itSheet);
            }
        },
        async getDocumentList() {
            try {
                let payload={
                    le_id:this.le_id
                }
                const response = await this.act_get_document_list(payload)
                this.DocumentList = response.data.data.map(doc => doc.documentName);

            }
            catch (error) {
                console.error("Error fetching document list:", error);
            };
        },

        async downloadGeneralReport() {
            try {
                this.isGeneralDownloading = true;
                const payload = {
                    data: {
                        empCode: this.employeeData.code,
                        legalEntityId: this.employeeData.legal_entity_id,
                        type: this.generalType,
                        clientCode: this.employeeData.legalEntityDetails.clientCode,
                    },
                };
                const data = await this.encryptData(payload);
                const res = await this.act_ess_download_general_report(data);
                const apiResponse = JSON.parse(await this.decrypt(res.data));
                const url = apiResponse.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "General_Report.pdf");
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    this.isGeneralDownloading = false;
                }, 1000);
            } catch (error) {
                this.toast = true;
                this.errmsg = "Details not Fetched";
                this.isGeneralDownloading = false;
            }
        },

        async downloadForm16Report() {
            try {
                this.isForm16Downloading = true;
                let roleState = localStorage.getItem("userRole");
                this.empCode = this.employeeData.code
                const date = new Date();
                const monthName = date.toLocaleString('default', { month: 'long' });
                let financialYearForApi 
                // let monthArray=["January","February","March"]
                //  if(monthArray.includes(monthName)){
                //      let year = this.paymentYear.split('-')[0];
                //      financialYearForApi = year
                //  }else{
                //     let year = this.paymentYear.split('-')[1];
                //     financialYearForApi = year
                //  }
                 let year = this.paymentYear.split('-')[0];
                     financialYearForApi = year
                let payload = {
                    data: {
                        empCode: this.empCode,
                        type: this.documentType.value, // "part A", "part B", "consolidated", or "general"
                        paymentYear: financialYearForApi, // e.g., "2024"
                        clientCode: this.employeeData.legalEntityDetails.clientCode,
                        legalEntityId: this.employeeData.legal_entity_id
                    }
                };

                let data = await this.encryptData(payload);
                let res = await this.act_get_Report_Download_Form(data);
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                const url = apiResponse.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Form_16_Report.pdf");
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    this.isForm16Downloading = false;
                }, 1000);
            } catch (error) {
                this.toast = true;
                this.errmsg = "Details not Fetched";
                this.isForm16Downloading = false;
            }
        },
        
        async getPayrollMonthsForITSheet() {
            try {
                let obj = {
                    emp_id: this.empId,
                    le_id: this.le_id
                }
                let payrollMonths = [];
                let itSheetYears = [];
                let months = [];
                let res = await this.act_getPayrollMonthListForITSheet(obj);
                let myObject = res.data.payload;
                if (res.data && res.data.payload) {
                    let mergedArray = [];
                    let itYtdSheetObject = res.data && res.data.payload;
                    const objectKeys = Object.keys(myObject).reverse();
                    for (let key of objectKeys) {
                        mergedArray.push(...myObject[key]);
                    }
                    for (const obj of mergedArray) {
                        const fiscalYear = obj.fy;
                        let month = ''
                        itSheetYears.push(fiscalYear)
                        for (const key in obj) {
                            if (key !== 'fy') {
                                month = `${key}-${fiscalYear}`;
                                payrollMonths.push(month);

                            }
                        }
                    }
                    // this.monthOptions = payrollMonths;
                    this.itMonth = payrollMonths[0];
                    this.isActive = this.month;
                    this.yearOptionsForITSheet = []
                   
       
                    this.yearOptionsForITSheet = []

                    const outputMap = {};

                    // Correct Financial Year month order: Apr to Mar
                    const fyMonthOrder = ["apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec", "jan", "feb", "mar"];

                    // Months that belong to previous financial year
                    const prevFYMonths = ["jan", "feb", "mar"];

                    Object.keys(itYtdSheetObject).forEach(yearKey => {
                        const year = parseInt(yearKey);

                        itYtdSheetObject[yearKey].forEach(item => {
                            const month = Object.keys(item).find(key => key !== 'fy');

                            let yearRange = "";

                            if (prevFYMonths.includes(month.toLowerCase())) {
                                // Jan, Feb, Mar => Previous Financial Year
                                yearRange = `${year - 1}-${year}`;
                            } else {
                                // Apr - Dec => Current Financial Year
                                yearRange = `${year}-${year + 1}`;
                            }

                            // Check if this FY already exists and replace if this month is later in FY order
                            if (!outputMap[yearRange] || fyMonthOrder.indexOf(month.toLowerCase()) > fyMonthOrder.indexOf(outputMap[yearRange].month.toLowerCase())) {
                                outputMap[yearRange] = {
                                    year: yearRange,
                                    month: month
                                };
                            }
                        });
                    });

                    // Convert map to output array
                    const output = Object.values(outputMap);
                    this.yearOptionsForITSheet = output
                    this.yearOptionsForITSheet = this.yearOptionsForITSheet.reverse();
                    let yearOptionsForITSheetYears = this.yearOptionsForITSheet.map(item => item.year);
                    this.paymentYearLists = yearOptionsForITSheetYears;
                }
            } catch (error) {
                this.toast = true;
                this.errmsg = error.message;
            }
        },
        async getPayrolMonthOptionsAdditionalPayslip(){
            try{
                this.monthOptionsAdditionalPayslip = []
                let obj = {
                    emp_id: this.empId,
                    le_id: this.le_id
                }
                const response  = await this.act_getPayrollMonthList_additional_payslip(obj)
                 let data = response.data.data
                const result = data.map(item => {
                    const shortMonth = item.paymentMonth.slice(0, 3).toLowerCase();
                    return `${shortMonth}-${item.paymentYear}`;
                }).reverse();
               this.monthOptionsAdditionalPayslip = result
               this.payslipMonthAdditionalPayslip = this.monthOptionsAdditionalPayslip[0]
            }catch(err){

            }
        },
        async getPayrollMonths() {
            try {
                let obj = {
                    emp_id: this.empId,
                    le_id: this.le_id
                }
                let payrollMonths = [];
                let itSheetYears = [];
                let months = [];
                let res = await this.act_getPayrollMonthList(obj);
                let myObject = res.data.payload;
                if (res.data && res.data.payload) {
                    let mergedArray = [];
                    let itYtdSheetObject = res.data && res.data.payload;
                    const objectKeys = Object.keys(myObject).reverse();
                    for (let key of objectKeys) {
                        mergedArray.push(...myObject[key]);
                    }
                    for (const obj of mergedArray) {
                        const fiscalYear = obj.fy;
                        let month = ''
                        itSheetYears.push(fiscalYear)
                        // Iterate through the properties of the object
                        for (const key in obj) {
                            if (key !== 'fy') {
                                month = `${key}-${fiscalYear}`;
                                payrollMonths.push(month);

                            }
                        }
                    }
                    this.monthOptions = payrollMonths;
                    this.payslipMonth = this.monthOptions[0];
                    // this.itMonth = this.monthOptions[0];
                    //this.monthOptions = payrollMonths.reverse();
                    this.isActive = this.month;
                    this.yearOptions = []

                    const outputMap = {};

                    // Correct Financial Year month order: Apr to Mar
                    const fyMonthOrder = ["apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec", "jan", "feb", "mar"];

                    // Months that belong to previous financial year
                    const prevFYMonths = ["jan", "feb", "mar"];

                    Object.keys(itYtdSheetObject).forEach(yearKey => {
                        const year = parseInt(yearKey);

                        itYtdSheetObject[yearKey].forEach(item => {
                            const month = Object.keys(item).find(key => key !== 'fy');

                            let yearRange = "";

                            if (prevFYMonths.includes(month.toLowerCase())) {
                                // Jan, Feb, Mar => Previous Financial Year
                                yearRange = `${year - 1}-${year}`;
                            } else {
                                // Apr - Dec => Current Financial Year
                                yearRange = `${year}-${year + 1}`;
                            }

                            // Check if this FY already exists and replace if this month is later in FY order
                            if (!outputMap[yearRange] || fyMonthOrder.indexOf(month.toLowerCase()) > fyMonthOrder.indexOf(outputMap[yearRange].month.toLowerCase())) {
                                outputMap[yearRange] = {
                                    year: yearRange,
                                    month: month
                                };
                            }
                        });
                    });
                     let output
                    if (this.employeeData.legal_entity_id == "dfba4011-0c5e-46cc-b4f4-99f5962f9ebe" || this.employeeData.legal_entity_id == "ac40f8c0-8ccb-46c3-aa7c-7958dc8014f0") {
                        const threshold =  "2024-2025";
                        output = Object.values(outputMap).filter(item => item.year >= threshold);
                    } else {
                        output = Object.values(outputMap);
                    }
                    // Convert map to output array
                    
                    
                      
                    this.yearOptions = output
                    this.yearOptions = this.yearOptions.reverse();   
                    //await this.downloadHTMLPayslip();
                }
            } catch (error) {
                this.toast = true;
                this.errmsg = error.message;
            }
        },
        async downloadEssAdditionalPayslip() {
            try {
                this.isAdditionalpayslipDownloading = true;
                let month = this.payslipMonthAdditionalPayslip.split("-")[0];
                this.getMonthName(month);
                let obj = {
                    empId: this.employeeData.id,
                    payMonth: month, // PL_3042
                    paymentYear: this.payslipMonth.split("-")[1],
                    clientCode: this.employeeData.legalEntityDetails.clientCode,
                    legalEntityId: this.employeeData.legal_entity_id
                }
                let data = await this.encryptData(obj);
                let res = await this.act_download_additional_payslip(data);
                console.log("svhgsfsfsghfgfhgvhgchgcfc",res)
                let apiResponse = JSON.parse(await this.decrypt(res.data.data));
                 console.log("apiResponse",apiResponse)
                const url = apiResponse.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    this.isAdditionalpayslipDownloading = false;
                }, 1000);
            } catch (error) {
                this.toast = true;
                this.errmsg = "Details not Fetched";
                this.isAdditionalpayslipDownloading = false;
            }
        },
        async downloadEssPayslip() {
            try {
                this.ispayslipDownloading = true;
                let month = this.payslipMonth.split("-")[0];
                this.getMonthName(month);
                let obj = {
                    empCode: this.employeeData.code, // PL_3042
                    empId: this.employeeData.id,
                    payMonth: this.newPayslipMonth, // PL_3042
                    clientName: this.employeeData.first_name,
                    reportType: "pdf",
                    paymentYear: this.payslipMonth.split("-")[1],
                    clientCode: this.employeeData.legalEntityDetails.clientCode,
                    legalEntityId: this.employeeData.legal_entity_id
                }
                let data = await this.encryptData(obj);
                let res = await this.act_download_new_payslip(data);
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                const url = apiResponse.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    this.ispayslipDownloading = false;
                }, 1000);
            } catch (error) {
                this.toast = true;
                this.errmsg = "Details not Fetched";
                this.ispayslipDownloading = false;
            }
        },
        async downloadYtdsheet() {
            try {
                this.isytdDownloading = true;
                // let month = this.payslipMonth.split("-")[0];
                // this.getMonthName(month);
                const date = new Date();
                const monthName = date.toLocaleString('default', { month: 'long' });
                let financialYearForApi 
                let monthArray=['jan','feb','mar']
                if(date.getFullYear() == this.ytdMonth.year.split('-')[1] || (date.getFullYear() == this.ytdMonth.year.split('-')[0] && !monthArray.includes(this.ytdMonth.month)))
                {  
                    if(monthArray.includes(this.ytdMonth.month) && (date.getFullYear() == this.ytdMonth.year.split('-')[1])){
                     let year = this.ytdMonth.year.split('-')[1];
                     financialYearForApi = year
                 }else if(date.getFullYear() == this.ytdMonth.year.split('-')[0] || date.getFullYear() == this.ytdMonth.year.split('-')[1] ){
                    let year = this.ytdMonth.year.split('-')[0];
                    financialYearForApi = year
                 }
                }
                else{
                    let year = this.ytdMonth.year.split('-')[1];
                    financialYearForApi = year
                    this.ytdMonth.month = 'mar'
                }
                // let monthArrayTwo = ['jan','feb','mar']
                // if(!monthArrayTwo.includes(this.ytdMonth.month) && date.getFullYear() == this.ytdMonth.year.split('-')[1]){
                //     financialYearForApi = Number(financialYearForApi)+1
                // }
                let roleState=localStorage.getItem("userRole")
                
                if(roleState === "ADMIN"){
                    roleState = "ADMIN"  
                    }
                    else if ( roleState === "EMPLOYEE"){
                    roleState = "EMPLOYEE"
                         }
                    else if ( roleState === "TEAMLEADER"){
                        roleState = "ADMIN"
                        }
                    else if(roleState === "CLIENTADMIN"){
                        roleState = "EMPLOYEE"
                        }
                        let obj = {
                    employee_id: this.empId,
                    financial_year:financialYearForApi,
                    role:roleState,
                    month:this.ytdMonth.month,
                    legal_entity_id:this.le_id

                    }
                // let data = await this.encryptData(obj);
                let res = await this.act_download_YTD_report(obj);

                // let apiResponse = JSON.parse(await this.decrypt(res.data));
                // const url = apiResponse.data.pdfPreSignedUrl;
                // const link = document.createElement("a");
                // link.href = url;
                // link.setAttribute("download", "YTD_Report.xlsx"); //or any other extension
                // document.body.appendChild(link);
                // link.click();
                
                setTimeout(() => {
                    this.isytdDownloading = false;
                }, 1000);
            } catch (error) {
                this.toast = true;
                this.errmsg = "Details not Fetched";
                this.isytdDownloading = false;
            }
        },

        getMonthName(month) {
            try {
                switch (month) {
                    case "jan":
                        this.newPayslipMonth = "January";
                        break;
                    case "feb":
                        this.newPayslipMonth = "February";
                        break;
                    case "mar":
                        this.newPayslipMonth = "March";
                        break;
                    case "apr":
                        this.newPayslipMonth = "April";
                        break;
                    case "may":
                        this.newPayslipMonth = "May";
                        break;
                    case "jun":
                        this.newPayslipMonth = "June";
                        break;
                    case "jul":
                        this.newPayslipMonth = "July";
                        break;
                    case "aug":
                        this.newPayslipMonth = "August";
                        break;
                    case "sep":
                        this.newPayslipMonth = "September";
                        break;
                    case "oct":
                        this.newPayslipMonth = "October";
                        break;
                    case "nov":
                        this.newPayslipMonth = "November";
                        break;
                    case "dec":
                        this.newPayslipMonth = "December";
                        break;
                    default:
                        break;
                }
            } catch (err) {
                this.toast = true;
                this.errmsg = err;
            }
        },

        async encryptData(payload) {
            try {
                const iv = crypto.randomBytes(8).toString('hex')
                const key = process.env.VUE_APP_PAYSLIP_SECRET;
                const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
                let encryptedText = Buffer.concat([
                    cipher.update(JSON.stringify(payload)),
                    cipher.final()
                ]);
                return {
                    iv: iv.toString(),
                    encryptedPacket: encryptedText.toString('base64')
                }
            } catch (err) {
                throw err;
            }
        },

        async decrypt(payload) {
            try {
                const key = process.env.VUE_APP_PAYSLIP_SECRET;
                const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
                const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
                return decrypted.toString();
            } catch (error) {
                // console.log(error)
            }
        },

        async downloadEssITSheet() {
            try {
                this.isItStatementDownloading = true;
                let financialYearForApi;
                let month = this.itMonth.month
                this.getMonthName(month);
                
                // Get month index to determine financial year (0=jan, 1=feb, 2=mar, 3=apr...)
                let monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
                let monthIndex = monthNames.indexOf(month);
                
                if (monthIndex < 3) {
                    // Jan, Feb, Mar belong to second year of financial year
                    financialYearForApi = this.itMonth.year.split('-')[1];
                } else {
                    // Apr-Dec belong to first year of financial year  
                    financialYearForApi = this.itMonth.year.split('-')[0];
                }
                
                let obj = {
                    'employee_id': this.empId
                }
                // let response = await this.act_getProfileData(obj);
                // this.employeeData = response.data.payload[0];
                let itObj = {
                    empCode: this.employeeData.code,
                    empId: this.employeeData.id,
                    month: this.newPayslipMonth,
                    clientName: this.employeeData.first_name,
                    reportType: "pdf",
                    assesmentYear: financialYearForApi,
                    clientCode: this.employeeData.legalEntityDetails.clientCode,
                    legalEntityId: this.employeeData.legal_entity_id // PL_3042
                }
                let data = await this.encryptData(itObj);
                let res = await this.act_download_new_itSheet(data);
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                const url = apiResponse.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "It Sheet.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    this.isItStatementDownloading = false;
                }, 1000);
            } catch (error) {
                this.toast = true;
                this.errmsg = "salary details from payroll not available for this month!";
                this.isItStatementDownloading = false;
            }
        },

        async downloadCtcReport() {
            try {
                this.isCompensationLoading = true;
                this.empCode = this.employeeData.code
                let itObj={
                    empCode: this.empCode,
                    legalEntityId: this.employeeData.legal_entity_id
                }
                let data = await this.encryptData(itObj);
                let res = await this.act_getCtcReport(data);
                let apiResponse = JSON.parse(await this.decrypt(res.data.data));
                // Define the string
                this.toast = false;
                const url = apiResponse.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    this.isCompensationLoading = false;
                }, 1000);
            } catch (error) {
                this.toast = true;
                this.errmsg = "Details not Fetched";
                this.isCompensationLoading = false;
            }
        },
        async processClearTax() {
             try {
                this.isclearTaxProcessing = true;
                let roleState = localStorage.getItem("userRole");
                this.empCode = this.employeeData.code

                let payload = {
                    data: {
                        empCode: this.empCode,
                        type: this.clearTaxDocumentType.value, // "part A", "part B", "consolidated", or "general"
                        paymentYear: this.clearTaxPaymentYear, // e.g., "2024"
                        clientCode: this.employeeData.legalEntityDetails.clientCode,
                        legalEntityId: this.employeeData.legal_entity_id
                    }
                };
                let data = await this.encryptData(payload);
                let res = await this.act_clear_tax_integration(data);
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                if(apiResponse.statusCode==200&&apiResponse.message==="details fetched successfully"){
                setTimeout(() => {
                this.isclearTaxProcessing = false;
                const url = apiResponse.data;
                const link = document.createElement('a');
                link.href = url;
                link.target = '_blank';
                link.rel = 'noopener noreferrer'; 
                link.click();
                }, 1000);
                }else{
                this.toast = true;
                this.errmsg = "Details not Fetched";
                this.isclearTaxProcessing = false;
                }
               
            } catch (error) {
                this.toast = true;
                this.errmsg = "Details not Fetched";
                this.isclearTaxProcessing = false;
            }
        },
    },
}
</script>
  
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.table-div {
    min-height: 350px;
    // max-height: 500px;
    margin-bottom: 175px;
    overflow: auto;
}

.declarationContainer {
    width: 100%;
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    border-radius: 8px;
    border: solid 1px #F0F0F0;
    background-color: #ebebeb;
    cursor: pointer;
}

.marginContainer {
    margin-top: 25px;
}

.headingContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
}

.headingLeftContainer {
    width: 100%;
    display: flex;
    gap: 15px;
}

.ReportContainer {
    width: 100%;
    padding: 10px 20px 10px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    border: solid 1px #F0F0F0;
    background-color: #f5f5f5;
    cursor: pointer;
}

.reportMainContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 80%;
}

.reportTitle {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 10px;
    margin-right: 20px;
    //margin-top: -20px;
    margin-bottom: 20px;
    // align-content: start;
}

.reportTitle>h3 {
    color: #34C0BD;
    margin-bottom: 5px;
}

.reportTitle>p {
    color: #777777;
    font-weight: 500;
    margin: 0;
}

.reportDownload {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    //flex-wrap: wrap;
    margin-left: 10px;
    margin-right: 20px;
}
.reportFormDownload {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    // gap: 10px;
    // flex-wrap: wrap;
    margin-left: 10px;
    margin-right: 10px; 
}

.formOptionContainer{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.downloadCompensation {
    justify-content: flex-end;
}

.reportDownloadLeft {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px
}

.reportDownloadLeft>span {
    color: #444444;
    font-weight: 500;
}


.reportDownloadLeftTextField {
    width: 180px;
    text-transform: capitalize;
    margin-top: -8px;
}
.generalReportDocumentDownload{
    width: 280px;
    text-transform: capitalize;
    margin-top: -8px;
}
.reportDownloadRight {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #5d409f;
    border: #5d409f solid 1px;
    color: #ffffff;
    border-radius: 4px;
    font-weight: bold;
    max-width: 240px;
    //max-height: 30px;
    text-align: center;
    padding: 5px 10px;
    margin-top: 6px;
    cursor: pointer;
    margin-right: 20px;
}
.styleReport{
padding: 5px 22px 5px 10px !important;
}

.reportArrow>img {
    align-self: end;
}


.income-tax-summary-box {
    border: solid 1px #F0F0F0;
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0px 1px 2px #f0f0f0;
}

.income-tax-text {
    font-size: 1.3rem;
    font-weight: bold;
    margin-bottom: 15px;
    color: #5a5a5a;
    margin-left: 8px;
    font-family: 'Montserrat';
}

.custom-col-3 {
    background: #F9F7FF;
    border: 1px solid #D9C9FF;
    padding: 16px;
    width: 25%; // 24% change to 22%
    border-radius: 8px;
}

.sm-text-it-summary {
    color: #8d8d8d;
    font-size: 1.0rem;
    font-weight: 500;
    font-family: 'Montserrat';
}

.sm-sub-text-it-summary {
    font-weight: 600;
    margin-top: 8px;
    color: #5a5a5a;
    font-family: 'Montserrat';
}

.sm-sub-text-right {
    font-family: 'Montserrat';
    font-size: 0.8rem;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 103px;
  gap: 10px;
}

.loader {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #5d409f;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  animation: spin 1s linear infinite;
}

.title-container{
    min-width: 90px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
  